import Link from "next/link";
import Close from "@components/Icons/CloseBold";

import { setGTMProductsFilterRemove } from "@lib/GTMHelper";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

// Active-filter chips: yellow like before (George). Brico keeps the pill shape, altex/MG the square.
const CHIP_CLASS = isBricoStore
  ? "bg-filterYellow rounded-full px-2 inline-flex items-center justify-between mb-2"
  : "bg-filterYellow rounded-sm px-2 inline-flex items-center justify-between mb-2";

const ActiveFilters = ({ activeFilters }) => (
  <ul
    className="flex flex-wrap mt-4 lg:mt-0 md:mb-4 text-xs leading-[20px]"
    data-test="FILTERS_ACTIVE_LIST"
  >
    {activeFilters.map((filter) => {
      if (filter.removeAll) {
        return (
          <li key={filter.removeUrl}>
            <Link href={filter.removeUrl}>
              <a
                title="Sterge tot"
                className="ml-2 text-sm text-red-brand hover:text-bleu-hover underline leading-18.2 -tracking-0.39"
                data-test="FILTERS_ACTIVE_LINK"
                onClick={() => {
                  setGTMProductsFilterRemove({
                    removedFilters: filter,
                    activeFilters,
                  });
                }}
              >
                sterge tot
              </a>
            </Link>
          </li>
        );
      } else {
        return (
          <li
            key={`${filter.slug}-${filter.filter.attributeSlug}-${filter.filter.slug}`}
            data-filter
            data-filtername={filter.label}
            data-filtervalue={filter.filter.slug}
            className="mr-3 md:mr-2"
          >
            <Link href={filter.removeUrl}>
              <a
                title="Sterge"
                className={CHIP_CLASS}
                data-test="FILTERS_ACTIVE_LINK"
                onClick={() => {
                  setGTMProductsFilterRemove({
                    removedFilters: filter,
                    activeFilters,
                  });
                }}
              >
                <span className="capitalize pr-2">
                  {filter.slug === "price"
                    ? filter.filter.slug
                    : filter.filter.label}
                </span>
                <Close width="9" height="9" />
              </a>
            </Link>
          </li>
        );
      }
    })}
  </ul>
);

export default ActiveFilters;
